import vue from "vue";
import AppVue from "@/App.vue";
import router from "./router";
import store from "./store";
import "./plugins/element";
import IconVue from "./components/icon/Icon.vue";
import HfSwitchVue from "./components/HfSwitch.vue";
import "./plugins/OneKeyTip";
import "./plugins/utils";
import "./plugins/axios";
import vueEcharts from "vue-echarts";
import "./plugins/tip";
import VoucherVue from "@/views/Voucher.vue";
import "../public/public.less";
// import { clipboard, ipcRenderer } from "electron";
import { Enviroment } from "./plugins/axios";

// google分析
// import uuid from "uuid";
// // let ana: any  = Analytics;
// let ua = "";
// if (process.env.VUE_APP_TITLE === "production") ua = "UA-122823484-1";
// else if (process.env.VUE_APP_TITLE === "development") ua = "UA-122823484-4";
// else if (process.env.VUE_APP_TITLE === "local") ua = "UA-122823484-4";
// else if (process.env.VUE_APP_TITLE === "jzs") ua = "UA-122823484-2";
// vue.prototype.ua = ua;
// // const analytics = new electronGoogleAnalytics(ua);
// vue.prototype.analytics = analytics;
// let uid = uuid();
// vue.prototype.uid = uid;
// // tslint:disable-next-line:no-backbone-get-set-outside-model
// analytics.set("uid", uid);

vue.config.productionTip = false;
vue.component("icon", IconVue);
vue.component("hf-switch", HfSwitchVue);
vue.component("v-chart", vueEcharts);
vue.component("voucher", VoucherVue);
// vue.use(OneKeyTip);
// console.log(OneKeyTip)


let main = new vue({
	router,
	store,
	render: h => h(AppVue)
}).$mount("#app");

vue.filter("currency", vue.utils.currency);

// ipcRenderer.on("removeLocal", (arg: any, fun: Function) => {
// 	let isRemember = localStorage.getItem("isRemember")
// 	if (isRemember === "false") {
// 		localStorage.removeItem("loginId");
// 		localStorage.removeItem("hashPassword");
// 		localStorage.removeItem("role");
// 		localStorage.removeItem("token");
// 	}
// 	fun();
// })

// ipcRenderer.on("set-size", (e, width, height) => {
// 	localStorage.setItem("window-width", width);
// 	localStorage.setItem("window-height", height);
// });

let windowWidth = localStorage.getItem("window-width");
let windowHeight = localStorage.getItem("window-height");

// if (windowWidth !== null && windowHeight !== null) {
// 	ipcRenderer.send("set-win-size", windowWidth, windowHeight);
// }

document.addEventListener("copy", e => {
	//取消默认事件，才能修改复制的值
	const selection = window.getSelection();
	if (selection !== null) {
		const sel = selection.toString();
		const reg = /^[0-9]+(.[0-9]{1,10})?$/;
		const copyTxt = sel.replace(/,/g, "");
		if (reg.test(copyTxt.trim())) {
			e.preventDefault();
			//复制的内容
			if (e.clipboardData) {
				vue.utils.sendToElectron("set-clipboard", copyTxt);
			}
		}
	}
});

// const threshold = 160; // 打开控制台的宽或高阈值  
// // 每秒检查一次
// setInterval(() => {
// 	if (window.outerWidth - window.innerWidth > threshold ||
// 		window.outerHeight - window.innerHeight > threshold) {

// 	}
// }, 1e3);

// 如果打开控制台，则刷新页面  
if (process.env.VUE_APP_TITLE !== "development" && !main.$store.state.account.role.includes("超级管理员")) {
	setInterval(() => {
		(a => {
			return (a => {
				// @ts-ignore
				return (Function("Function(arguments[0]+'" + a + "')()"))
			})(a)
			// @ts-ignore
		})("bugger")("de", 0, 0, (0, 0));
	}, 1e3);
}

export default main;
